import { createContext, useContext } from 'react'
import { LEGACY_PORTAL_BRAND } from './portalBrandStatus'

export const PortalBrandContext = createContext(LEGACY_PORTAL_BRAND)

export const usePortalBrandContext = () => useContext(PortalBrandContext)
